import React from 'react'
const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M4.18746 43.75L47.9166 25L4.18746 6.25L4.16663 20.8333L35.4166 25L4.16663 29.1667L4.18746 43.75Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
